import React, { Component } from "react";

class DetailsFeatureBox extends Component {
  render() {
    return (
      <div className="heading-bx">
        <h1 className="title mb-0 h3">GE DIN BIL DEN VÅRD DEN FÖRTJÄNAR MED PROFESSIONELL TVÄTT OCH REKOND!</h1>
        <p className="pt-4">
          En ren bil är inte bara trevlig att köra utan kan också förlänga dess livslängd. Vi erbjuder både utvändig och
          invändig rengöring med noggranna metoder och högkvalitativa produkter. Från handtvätt och vaxning till
          polering och klädseltvätt– vi har allt för att din bil ska se som ny ut.
        </p>
        <p>
          Vår rekondtjänst går ett steg längre och inkluderar djuprengöring, skydd och detaljerad behandling av din bils
          interiör och exteriör. Vi kan även hjälpa till med luktborttagning och motorrengöring för att säkerställa att
          hela bilen är i toppskick.
        </p>
        <p>Boka en tid för rekond hos oss och njut av känslan av en fräsch och välskött bil.</p>
      </div>
    );
  }
}

export default DetailsFeatureBox;
